import React from 'react';
import { Stack } from 'react-bootstrap';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import { SelectSingle } from '../../Selects/SelectSingle';

type StepSelectEmployeeProps = {
  employees: ReadonlyArray<{
    Id: string;
    Name: string;
  }>;
  selectedEmployeeId: string | null;
  onEmployeeSelect: (employeeId: string | null) => void;
};

export const StepSelectEmployee: React.FC<StepSelectEmployeeProps> = ({
  employees,
  selectedEmployeeId,
  onEmployeeSelect,
}) => {
  const t = useNamespacedTranslation('changeRequests.requestForm');

  return (
    <Stack gap={0}>
      <div className="text-center py-5">
        <h5 className="mb-4">{t('selectEmployee')}</h5>
        <SelectSingle
          name="employee"
          placeholder={t('employee.placeholder')}
          options={employees.map((emp) => ({
            value: emp.Id,
            label: emp.Name,
          }))}
          value={selectedEmployeeId || ''}
          onChange={(value) => {
            onEmployeeSelect(value);
          }}
        />
      </div>
    </Stack>
  );
};
